import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=1fe98207&scoped=true&"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerModal.vue?vue&type=style&index=0&id=1fe98207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe98207",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe98207')) {
      api.createRecord('1fe98207', component.options)
    } else {
      api.reload('1fe98207', component.options)
    }
    module.hot.accept("./CreateCustomerModal.vue?vue&type=template&id=1fe98207&scoped=true&", function () {
      api.rerender('1fe98207', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Customer/Modals/CreateCustomerModal.vue"
export default component.exports